/**
 * Raw nav-item option data for the main sidebar nav, lifted unchanged out
 * of SidebarMenu.js so both the old sidebar (SidebarMenu.js, via
 * useSidebarNavData's `legacy` shape) and the new one (Sidebar.jsx, via
 * useSidebarNavData's `nav` shape) derive from one source while both
 * shells coexist behind the app-shell flag.
 *
 * Children of a group render with no icon, 36px row (see
 * design_handoff_sidebar_nav: sub-items lose their icons entirely) — true
 * in both the old SideMenuItem `child` prop and the new SidebarNavItem
 * `child` prop, independently.
 */
import appConfig from "../../../../appConfig";

export const widgetMenuOptions = [
  {
    label: "Calendars",
    className: "nav-calendar",
    id: "calendar",
    url: "/calendars",
  },
  {
    label: "Groups",
    className: "nav-groups",
    id: "groups",
    url: "/groups",
  },
  {
    label: "Event alerts",
    className: "nav-alerts",
    id: "alerts",
    url: "/alerts",
  },
  {
    label: "Sign-up forms",
    className: "nav-signup",
    id: "signup",
    url: "/signups",
  },
  {
    label: "Mailchimp",
    className: "nav-mailchimp",
    id: "mailchimp",
    url: "/mailchimp-instructions",
    alpha: true,
  },
].filter((i) => appConfig.widgets.includes(i.id));

export const userMenuOptions = [
  {
    label: "Integrations",
    icon: "Dataflow04",
    className: "nav-dashboard",
    id: "integrations",
    url: "/integrations",
  },
  {
    label: "Websites",
    icon: "Browser",
    className: "nav-dashboard",
    id: "domains",
    url: "/domains",
  },
];

export const reportsMenuOptions = [
  {
    label: "Event engagement",
    className: "nav-plan-usage",
    id: "eventEngagement",
    url: "/reports/event-engagement",
  },
  {
    label: "Plan usage",
    className: "nav-plan-usage",
    id: "planUsage",
    url: "/reports/plan-usage",
  },
];

export const getAdminOptions = (t, currentYear, disabled) => [
  {
    label: t("Organizations"),
    id: "organizations",
    url: `/${appConfig.links.organizations}`,
    disabled,
  },
  {
    label: "Users",
    id: "users",
    url: "/users",
    disabled,
  },
  {
    label: "Accounts",
    id: "accounts",
    url: "/accounts/" + currentYear,
    disabled,
  },
  {
    label: "Queues",
    id: "queueWorkers",
    url: "/queue-workers",
    disabled,
  },
];
